export const IsAuthenticated ="IsAuthenticated";